var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHistory08(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 14,
      strokeMiterlimit: 10
    },
    d: "M222.873 205.891H63.947c-16.313 0-29.537-13.224-29.537-29.537V73.463c0-16.313 13.224-29.537 29.537-29.537h158.926c16.313 0 29.537 13.224 29.537 29.537v102.891c0 16.313-13.224 29.537-29.537 29.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 21,
      strokeMiterlimit: 10
    },
    d: "M143.41 207.878v44.784"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 19,
      strokeMiterlimit: 10
    },
    d: "M143.41 252.662h-76M219.41 252.662h-76"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 14,
      strokeMiterlimit: 10
    },
    d: "m89.884 163.089 45.752-79.244c3.455-5.985 12.094-5.985 15.549 0l45.752 79.244c3.455 5.985-.864 13.466-7.774 13.466H97.658c-6.91-.001-11.229-7.482-7.774-13.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.51,
      fill: "none",
      stroke: "#282828",
      strokeWidth: 14,
      strokeMiterlimit: 10
    },
    d: "m57.158 137.872 32.379-56.083c2.445-4.236 8.559-4.236 11.004 0l32.379 56.083c2.445 4.236-.611 9.53-5.502 9.53H62.66c-4.891-.001-7.948-5.295-5.502-9.53zM154.636 137.872l32.379-56.083c2.445-4.236 8.559-4.236 11.004 0l32.379 56.083c2.445 4.236-.611 9.53-5.502 9.53h-64.759c-4.889-.001-7.946-5.295-5.501-9.53z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory08);
export default __webpack_public_path__ + "static/media/icon_history-08.cfe7bc8f25be24ff63beabbd879a5465.svg";
export { ForwardRef as ReactComponent };